import React from 'react';
import { useTranslation } from 'react-i18next';
import { translatePhase } from '../../../utils/fieldTranslations';

/**
 * MetaInfoSection - Compact task metadata display
 */
function MetaInfoSection({ task, formatDate }) {
  const { i18n } = useTranslation();
  return (
    <div className="flex flex-wrap gap-3 text-xs text-slate-500 border-t border-slate-800 pt-4 mt-4" data-testid="meta-info-section">
      {task.deadline && (
        <span className={`flex items-center gap-1 ${task.is_overdue && task.status !== 'completed' ? 'text-rose-400 font-medium' : ''}`}>
          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
          Frist: {formatDate(task.deadline)}
        </span>
      )}
      {task.category && (
        <span className="flex items-center gap-1">
          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
          </svg>
          {task.category}
        </span>
      )}
      {task.ik_section && (
        <span className="flex items-center gap-1">
          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          IK §5 punkt {task.ik_section}
        </span>
      )}
      {task.phase && (
        <span className="px-2 py-0.5 bg-slate-800 text-slate-400 rounded capitalize">{translatePhase(task.phase, i18n.language)}</span>
      )}
    </div>
  );
}

export default MetaInfoSection;
